// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QCfb_k37Q8MX7C {
  flex-shrink: 0;
  margin: var(--ds-space-0, 0);
  transition: 0.1s ease;
}
.ebH6gvCfV6sKiq {
  padding-left: var(--ds-space-100, 8px);
}
.board-wrapper.is-show-menu .QCfb_k37Q8MX7C {
  display: none;
}
.PAr279rz67r0C8 {
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
._9gVZKx4ZK5x4I {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: -44px;
}
@media print {
  ._9gVZKx4ZK5x4I {
    display: none;
  }
}
`, ""]);
// Exports
export var showSidebarButton = `QCfb_k37Q8MX7C`;
export var showSidebarButtonWithText = `ebH6gvCfV6sKiq`;
export var sidebarExtraMargin = `PAr279rz67r0C8`;
export var popover = `_9gVZKx4ZK5x4I`;
export default ___CSS_LOADER_EXPORT___;
